module.exports = __webpack_public_path__ + "static/media/1-custom-cut-mat-board-for-ikea-SILVERHOJDEN-frame-(36in-x-27in-91cm-x-6cm).ae6015c0.webp";